// Platform-owner branding config. Replace these values later without touching UI code.
export const BRAND = {
  name: "YOUR BRAND",
  wordmark: "YOUR · BRAND",
  tagline: "BARBER PORTFOLIO PLATFORM",
  short: "Profesyonel barberler için premium dijital vitrin.",
  hero_image: "https://images.unsplash.com/photo-1622286346003-b73a7d4b3c72?w=1600&q=80",
  favicon_url: "",
};
